module.exports = __webpack_public_path__ + "9972776c1237b3feb28e4bc8f65f19c1.png";